module.exports = __webpack_public_path__ + "src/components/WishListModal/Banner.jpg?9c79a080";


//////////////////
// WEBPACK FOOTER
// ./src/components/WishListModal/Banner.jpg
// module id = 3388
// module chunks = 8